"use strict";
/*
 * Created on Fri Jul 20 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AdtFlag_1 = require("./AdtFlag");
/**
 * Base flag for state representation of an entity. The number of state flags for one entity
 * should not be limited, though it is likely that only one flag will be used in most cases.
 * It is the responsibility of the end system to process flags and periodically update them.
 *
 * @author JMe
 */
// tslint:disable:max-classes-per-file


var EntityStateFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(EntityStateFlag, _AdtFlag_1$AdtFlag);

  function EntityStateFlag() {
    _classCallCheck(this, EntityStateFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntityStateFlag).apply(this, arguments));
  }

  _createClass(EntityStateFlag, null, [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(EntityStateFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(EntityStateFlag, data);
    }
  }]);

  return EntityStateFlag;
}(AdtFlag_1.AdtFlag);

exports.EntityStateFlag = EntityStateFlag;
EntityStateFlag.TAG = '__EntityStateFlag__';
/**
 * The flag represents situation when some entity has been newly created, i.e. in an external system.
 */

var NewEntity =
/*#__PURE__*/
function (_EntityStateFlag) {
  _inherits(NewEntity, _EntityStateFlag);

  function NewEntity() {
    _classCallCheck(this, NewEntity);

    return _possibleConstructorReturn(this, _getPrototypeOf(NewEntity).apply(this, arguments));
  }

  _createClass(NewEntity, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return NewEntity;
}(EntityStateFlag);

exports.NewEntity = NewEntity;
NewEntity.TAG = EntityStateFlag.register(NewEntity);
/**
 * The flag represents situation when some entity has been modified, i.e. in an external system.
 */

var ModifiedEntity =
/*#__PURE__*/
function (_EntityStateFlag2) {
  _inherits(ModifiedEntity, _EntityStateFlag2);

  function ModifiedEntity() {
    _classCallCheck(this, ModifiedEntity);

    return _possibleConstructorReturn(this, _getPrototypeOf(ModifiedEntity).apply(this, arguments));
  }

  _createClass(ModifiedEntity, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return ModifiedEntity;
}(EntityStateFlag);

exports.ModifiedEntity = ModifiedEntity;
ModifiedEntity.TAG = EntityStateFlag.register(ModifiedEntity);
/**
 * The flag represents situation when some entity has been deleted, i.e. in an external system.
 */

var DeletedEntity =
/*#__PURE__*/
function (_EntityStateFlag3) {
  _inherits(DeletedEntity, _EntityStateFlag3);

  function DeletedEntity() {
    _classCallCheck(this, DeletedEntity);

    return _possibleConstructorReturn(this, _getPrototypeOf(DeletedEntity).apply(this, arguments));
  }

  _createClass(DeletedEntity, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return DeletedEntity;
}(EntityStateFlag);

exports.DeletedEntity = DeletedEntity;
DeletedEntity.TAG = EntityStateFlag.register(DeletedEntity);
/**
 * The flag represents situation when some entity has been in some way processed, i.e. within data integration. It should be used
 * only in specific situations as helper and for a short time and then deleted. For example, when we need to detect, whether or not
 * an entity was processed during data integration so we could determine, whether entity was deleted from external system or not.
 *
 * @deprecated not suitable for handling this kind of situations because of queries on array ($nin required) are inefficient.
 * @see {@link IProcessable processable} interface
 */

var ProcessedEntity =
/*#__PURE__*/
function (_EntityStateFlag4) {
  _inherits(ProcessedEntity, _EntityStateFlag4);

  function ProcessedEntity() {
    _classCallCheck(this, ProcessedEntity);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProcessedEntity).apply(this, arguments));
  }

  _createClass(ProcessedEntity, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return ProcessedEntity;
}(EntityStateFlag);

exports.ProcessedEntity = ProcessedEntity;
ProcessedEntity.TAG = EntityStateFlag.register(ProcessedEntity);